/*
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PermissionContext } from "../../contexts/PermissionContext";
import { AuthContext } from "../../contexts/AuthContext";
import Notification from "../../components/UI/Notification";
import RolePermissionsForm from "../Roles/components/RolePermissionsForm";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { FaArrowLeft } from "react-icons/fa";

const AddPermission = () => {
  const { addPermission } = useContext(PermissionContext);
  const { roles: userRoles, token } = useContext(AuthContext);
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();

  const getRoleBasedRouteLocal = (route) => {
    if (!userRoles || userRoles.length === 0) return route;
    return getRoleBasedRoute(route, userRoles);
  };

  const handleCreatePermissionWithGranularData = async (data) => {
    if (!data.name.trim()) {
      setNotification({
        message: "Permission name cannot be empty.",
        type: "error",
      });
      return;
    }

    // Following the same structure as Roles
    const payload = {
      name: data.name,
      permissions: data.permissions || {},
    };

    try {
      await addPermission(token, payload);
      navigate(getRoleBasedRouteLocal("/admin/permissions"), {
        state: { successMessage: "Permission created successfully." },
      });
    } catch (err) {
      setNotification({
        message: `Error: ${err.message || "Failed to add permission."}`,
        type: "error",
      });
    }
  };

  return (
    <div className="w-full">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="p-4 md:p-6 lg:p-8 max-w-[1500px] mx-auto">
        <button
          type="button"
          onClick={() => navigate(getRoleBasedRouteLocal("/admin/permissions"))}
          className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 font-medium mb-6 transition-colors group"
        >
          <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
          Back to Permissions
        </button>

        <RolePermissionsForm
          type="Permission"
          onSave={handleCreatePermissionWithGranularData}
          onCancel={() =>
            navigate(getRoleBasedRouteLocal("/admin/permissions"))
          }
        />
      </div>
    </div>
  );
};

export default AddPermission;
*/
import React from "react";
const AddPermission = () => {
  return null;
};
export default AddPermission;
